import {createAction} from '@reduxjs/toolkit';

export const setTileMode = createAction('tiles/setMode');

export const setProcessColor = createAction('tiles/setProcessColor');

export const setProcess = createAction('tiles/setProcess');

export const setCurve = createAction('tiles/setColorCurve');

export const setHistogram = createAction('tiles/setHistogram');

export const setColorEnhanceMode = createAction('tiles/setColorEnhanceMode');

export const setImageFilter = createAction('tiles/setImageFilter');
